import dayjs from 'dayjs';

import { OrganizationPlanSchema } from '@/types/schema';

const thirtyDaysFromNow = dayjs().add(30, 'day');

export const isCancelledPlan = (
  currentPlan?: OrganizationPlanSchema | null,
  upcomingPlan?: OrganizationPlanSchema | null
): boolean => {
  return (
    !!currentPlan?.ends_on &&
    dayjs(currentPlan.ends_on).isBefore(thirtyDaysFromNow) &&
    (!upcomingPlan || upcomingPlan.tier === 'free')
  );
};
